import { render } from "./ResultList.vue?vue&type=template&id=4945c04e"
import script from "./ResultList.vue?vue&type=script&lang=ts"
export * from "./ResultList.vue?vue&type=script&lang=ts"
script.render = render

export default script